<template>
  <VSlideGroup
    mandatory
    :show-arrows="true"
    class="db-vacancy-slider"
  >
    <template v-slot:prev>
      <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0L9.41 1.41L3.83 7H16V9H3.83L9.41 14.59L8 16L0 8L8 0Z" fill="black"/>
      </svg>
    </template>
    <template v-slot:next>
      <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="black"/>
      </svg>
    </template>
    <VSlideItem
      v-for="candidate of candidates"
      :key="candidate.id"
      class=""
    >
      <CandidateBigSliderItem
        :candidate="candidate"
        class=""
      />
    </VSlideItem>
  </VSlideGroup>
</template>

<script>
import CandidateBigSliderItem from './CandidateBigSliderItem.vue';

export default {
  name: 'CandidateBigSlider',
  components: { CandidateBigSliderItem },
  props: {
    candidates: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  .db-vacancy-slider {
    position: relative;
    .v-slide-group__wrapper {
      padding: 1.25rem 0 3.875rem 0.625rem;
      margin-left: -0.625rem;
    }
    .v-slide-group__content {
      padding-right: 0.625rem;
      margin-right: -0.625rem;
    }
    .v-slide-group__prev, .v-slide-group__next {
      width: 2.5rem;
      min-width: auto;
      height: 2.5rem;
      border-radius: 0.625rem;
      background: #FFFFFF;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.16);
      position: absolute;
      bottom: 0;
    }
    .v-slide-group__prev {
      left: 50%;
      margin-left: -4rem;
      z-index: 2;
    }
    .v-slide-group__next {
      right: 50%;
      margin-right: -4rem;
    }
  }
  @media #{map-get($display-breakpoints, 'xs-only')} {
    .db-vacancy-slider {
      .v-slide-group__wrapper {
        padding-bottom: 1.25rem;
        margin-left: -0.625rem;
      }
      .v-slide-group__prev, .v-slide-group__next {
        display: none;
      }
    }
  }
</style>
